import { Logo } from './Logo'

const SIZES = {
  sm: { mark: 18, text: 'text-lg' },
  md: { mark: 26, text: 'text-3xl' },
  lg: { mark: 34, text: 'text-4xl' },
}

export function Lockup({ size = 'md', variant = 'squircle', className = '', kicker = null, kineticSettle = false }) {
  const cfg = SIZES[size] || SIZES.md
  return (
    <div className={`inline-flex flex-col ${className}`}>
      <div className="flex items-center gap-2">
        <Logo variant={variant} size={cfg.mark} />
        <span
          className={`font-display ${cfg.text} text-white ${kineticSettle ? 'kinetic-settle' : ''}`}
          style={{ fontVariationSettings: '"wght" 700, "opsz" 96', letterSpacing: '-0.045em', lineHeight: 1 }}
        >
          clixyads
        </span>
      </div>
      {kicker && <span className="kicker mt-2 block">{kicker}</span>}
    </div>
  )
}
